<template>
    <div class="">
      <b-container class="topContainer">
        <div class="CentreSupportText">
          <h4 id="pageHeader">Raise a Support Request</h4>
          <p>
            Use this form to submit any incidents, problems or support requests
          </p>
          <p>Please complete the below details</p>
        </div>
  
        <div class="outerGreyContainer">
          <div class="TextInputs">
            <div class="inputBoxContainer">
              <div class="leftBox">
                <div class="leftText">Full Name</div>
                <div class="rightText">
                  <input
                    type="text"
                    placeholder="Request Raised by"
                    v-model="userID"
                    required
                    :readonly="true"
                    @focus="modal = false"
                  />
                </div>
              </div>
              <div class="rightBox">
                <div class="leftText">Contact Email</div>
                <div class="rightText">
                  <input
                    maxlength="90"
                    type="email"
                    placeholder="User Email Address"
                    v-model="UserEmail"
                    @focus="modal = false"
                    required
                  />
                </div>
              </div>
  
              <div class="leftBox">
                <div class="leftText">Request Type</div>
                <div class="rightText">
                  <select
                    name="RequestDrop"
                    v-model="RequestDrop"
                    id="RequestDrop"
                    @focus="modal = false"
                    required
                  >
                    <option select disabled value=""></option>
                    <option>Clarence Software Support</option>
                    <option>Maintenance Support</option>
                  </select>
                </div>
              </div>
              <div class="rightBox">
                <div class="leftText">Location</div>
                <div class="rightText">
                  <input
                    type="text"
                    placeholder="Request Raised by"
                    v-model="this.userLocation"
                    required
                    :readonly="true"
                    @focus="modal = false"
                  />
                </div>
              </div>
            </div>
  
            <!--
         <b-row class="topRow">
          <b-col class="supportInputCol" > <label for="UserID">Full Name:</label>
            <input
              type="text"
              placeholder="Request Raised by"
              v-model="userID"
              required
              :readonly="true"
              @focus="modal = false"
          />
          </b-col>
          <b-col class="supportInputCol" ><label for="Useremail">Contact Email:</label>  
            <input
            maxlength="90"
              type="email"
              placeholder="User Email Address"
              v-model="UserEmail"
              @focus="modal = false"
              required
          /></b-col>
        </b-row>
       
        <b-row class="bottomRow">
          <b-col class="supportInputCol" ><label for="RequestDrop" >Request:</label>  <select
              name="RequestDrop"
              v-model="RequestDrop"
              id="RequestDrop"
              @focus="modal = false"
              required
            >
              <option select disabled value=""></option>
              <option>Clarence Software Support</option>
              <option>Maintenance Support</option>
              
            </select></b-col
          >
           <b-col class="supportInputCol" ><label for="Location">Location:</label>  
           <input
              type="text"
              placeholder="Request Raised by"
              v-model="this.userLocation"
              required
              :readonly="true"
              @focus="modal = false"
          />
  
            </b-col>
        </b-row> -->
          </div>
          <div class="radioButtonContainer">
            <div class="radioButtonRow">
              <b-form-radio-group
                v-model="selected"
                :options="options"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                @focus="modal = false"
              ></b-form-radio-group>
            </div>
          </div>
          <b-row>
            <b-col sm>
              <p class="descriptionHelper">
                Please describe in as much detail as possible the reason for the
                request. (1000 Character Max)
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm>
              <textarea
                class="supportTextArea"
                v-model="message"
                placeholder="Description"
                rows=""
                cols=""
                @focus="modal = false"
                maxlength="1000"
              ></textarea>
            </b-col>
          </b-row>
          <b-row class="buttonRow">
            <b-col sm>
              <button id="button" class="button" v-on:click="SubmitSearch()">
                Submit
              </button>
              <button class="button" v-on:click="resetValue()">Clear</button>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="Container">
        <h5 class="ViewHeading">Current Open Requests for User</h5>
        <br />
        <div id="#">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="Requesttable"
          ></b-pagination>
  
          <b-table
            id="RequestTable"
            :items="this.items"
            :fields="this.UserHeaders"
            @row-dblclicked="rowDblClickHandler"
            empty-text="You currently dont have any open support requests"
            :per-page="perPage"
            :current-page="currentPage"
            no-border-collapse
            hover
            show-empty
            responsive
            small
            sticky-header
          >
            <template v-slot:empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(Action)="{ item }">
              <b-button
                variant="outline-info"
                v-on:click="
                  showActionModal(
                    item[0],
                    item[1],
                    item[2],
                    item[3],
                    item[4],
                    item[5],
                    item[6],
                    item[7],
                    item[8]
                  )
                "
              >
                Cancel
              </b-button>
            </template>
          </b-table>
  
          <br />
        </div>
      </div>
      <b-modal
        ref="HCUSupportActionModal"
        id="HCUSupportActionModal"
        hide-footer
        title="Support Action Form"
        content-class="Modal"
      >
        <div>
          <!-- {{this.item0 + this.item1 + this.item2 + this.item3 + this.item4 + this.item5 + this.item6 + this.item7 + this.item8}} -->
          <p class="head">
            Support Ticket: {{ this.item0 }} - Category: {{ this.item6 }}
          </p>
          <p class="head">Location: {{ this.item3 }}</p>
          <p class="head">
            Raised By: {{ this.item1 }} - Raised On: {{ this.item4 }}
          </p>
          <p class="head">Urgency: {{ this.item5 }} - Status: {{ this.item8 }}</p>
          <p class="head">Status: {{ this.item7 }}</p>
          <br />
          <p>Would you like to cancel this request?</p>
        </div>
        <div>
          <button class="button" v-on:click="postModal()">Yes</button>
          <button class="button" v-on:click="resetmodal()">No</button>
        </div>
      </b-modal>
    </div>
  </template>
  <script>
  import axios from "axios";
  export default {
    computed: {
      rows() {
        return this.items.length;
      },
    },
    mounted() {
      let url =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/supportrequests";
      let PostHeaders = this.$apikeyPost;
      let user = this.$UserURN;
      let PostData = {
        Location: "",
        RequestType: "LoadUser",
        SRType: "",
        DateRaised: "",
        Urgency: "",
        Status: "",
        Category: "",
        User: user,
        Text: "",
        Email: "",
        Company: "",
      };
      axios
        .post(url, PostData, PostHeaders)
        .then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        })
        .catch((err) => {
          "ERROR: ====", err;
        });
    },
  
    data() {
      return {
        selected: "Non Urgent",
        options: [
          { item: "Highly Urgent", name: "Highly Urgent (12hr)" },
          { item: "Urgent", name: "Urgent (24hr)" },
          { item: "Routine", name: "Routine (48hr)" },
          { item: "Non Urgent", name: "Non Urgent (1 Week)" },
        ],
        UserHeaders: [],
        items: [],
        userID: this.$FullName,
        response: null,
        ArrTest: [],
        RequestDrop: null,
        location: "",
        UserEmail: null,
        message: null,
        locations: [],
        filteredlocation: null,
        filteredlocations: [],
        modal: false,
        perPage: 5,
        currentPage: 1,
        item0: "",
        item1: "",
        item2: "",
        item3: "",
        item4: "",
        item5: "",
        item6: "",
        item7: "",
        item8: "",
        rowDblClickHandler: "",
        userLocation: this.$Location,
        TESTARRAY: ["CancelRequest"],
        buttonCooldown: false,
      };
    },
  
    methods: {
      btnCooldown: function() {
        let buttonid = "button";
        const button = document.querySelector("#" + buttonid + "");
        if (this.buttonCooldown == true) {
          const disableButton = () => {
            button.disabled = true;
          };
          button.addEventListener("click", disableButton);
        } else if (this.buttonCooldown == false) {
          button.disabled = false;
        }
      },
      SubmitSearch() {
        this.buttonCooldown = true;
  
        if (
          this.RequestDrop === null ||
          this.location === null ||
          this.UserEmail === null ||
          this.Message === null
        ) {
          this.buttonCooldown = false;
  
          alert("Please complete all fields before submitting");
        } else if (this.UserEmail != null) {
          this.emailIsValid(this.UserEmail);
          if (this.EmailVal === false) {
            this.buttonCooldown = false;
  
            alert("Email Address does not appear to be valid");
          } else {
            if (this.RequestDrop === "Clarence Software Support") {
              this.AlertCategory = "IT System Alert";
            } else if (this.RequestDrop === "Maintenance Support") {
              this.AlertCategory = "Maintenance Alert";
            }
  
            if (this.userLocation != null) {
              let newMessage = JSON.stringify(this.message);
              let newMessage2 = newMessage.replace(/^"|"$/g, "");
  
              let user = this.$UserURN;
              let postparam = {
                Location: this.userLocation,
                RequestType: "Submit",
                SRType: this.RequestDrop,
                Urgency: this.selected,
                Status: "New",
                User: user,
                Category: this.AlertCategory,
                Text: newMessage2,
                Email: this.UserEmail,
                Company: "",
                DateRaised: "",
              };
              let PostHeaders = this.$apikeyPost;
              let posturl =
                "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
                this.$environment +
                "/supportrequests";
              axios.post(posturl, postparam, PostHeaders).then((response) => {
                response;
                this.buttonCooldown = false;
  
                alert("Status Submitted");
              });
              (this.RequestDrop = null),
                (this.location = ""),
                (this.UserEmail = null),
                (this.message = null),
                (this.selected = "Non Urgent"),
                (this.userID = this.$FullName),
                (this.EmailVal = false),
                (this.modal = false);
              this.refreshTable();
            } else {
              alert("Please select a location from the autocomplete list");
              (this.RequestDrop = null),
                (this.location = ""),
                (this.UserEmail = null),
                (this.message = null),
                (this.selected = "Non Urgent"),
                (this.userID = this.$FullName),
                (this.EmailVal = false),
                (this.modal = false);
            }
          }
        }
      },
      resetValue() {
        (this.RequestDrop = null),
          (this.location = ""),
          (this.UserEmail = null),
          (this.message = null),
          (this.selected = "Non Urgent"),
          (this.userID = this.$FullName);
        (this.EmailVal = false), (this.modal = false);
      },
  
      refreshTable() {
        let url =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportrequests";
        let PostHeaders = this.$apikeyPost;
        let user = this.$UserURN;
        let PostData = {
          Location: "",
          RequestType: "LoadUser",
          SRType: "",
          DateRaised: "",
          Urgency: "",
          Status: "",
          Category: "",
          User: user,
          Text: "",
          Email: "",
          Company: "",
        };
        axios.post(url, PostData, PostHeaders).then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
      },
      emailIsValid(email) {
        this.EmailVal = /\S+@\S+\.\S+/.test(email);
      },
  
      showActionModal: function(
        var0,
        var1,
        var2,
        var3,
        var4,
        var5,
        var6,
        var7,
        var8
      ) {
        this.item0 = var0;
        this.item1 = var1;
        this.item2 = var2;
        this.item3 = var3;
        this.item4 = var4;
        this.item5 = var5;
        this.item6 = var6;
        this.item7 = var7;
        this.item8 = var8;
  
        this.$refs["HCUSupportActionModal"].show(
          this.item0,
          this.item1,
          this.item2,
          this.item3,
          this.item4,
          this.item5,
          this.item6,
          this.item7
        );
      },
      resetmodal() {
        this.item0 = "";
        this.item1 = "";
        this.item2 = "";
        this.item3 = "";
        this.item4 = "";
        this.item5 = "";
        this.item6 = "";
        this.item7 = "";
        this.$refs["HCUSupportActionModal"].hide();
      },
  
      postModal() {
        this.LookUpRequest = {
          Actions: ["UpdateStatus"],
          RequestID: this.item0,
          NewStatus: "Cancelled",
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/supportactions";
        let LookUpHeaders = this.$apikeyPost;
  
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Support Request has been cancelled");
            this.$refs["HCUSupportActionModal"].hide();
            this.resetValue();
            this.refreshTable();
          })
          .catch((err) => {
            "Error: ===", err;
          });
        this.items = [];
      },
  
      filterLocations: function() {
        if (this.location.length == 0) {
          this.filteredlocations = this.locations;
        }
        this.filteredlocations = this.locations.filter((location) => {
          return location
            .toString()
            .toLowerCase()
            .startsWith(this.location.toString().toLowerCase());
        });
      },
  
      setLocation(location) {
        this.location = location;
        this.modal = false;
      },
    },
    watch: {
      location() {
        this.filterLocations();
      },
      buttonCooldown() {
        this.btnCooldown();
      },
    },
  };
  </script>
  <style scoped>
  input[type="text"],
  input[type="date"],
  input[type="email"],
  select {
    width: 100%;
  
    padding: 7px 7px 7px 7px;
  
    border: solid 1px rgba(200, 200, 200, 0.5);
  
    border-radius: 15px;
  
    background-color: rgb(245, 245, 245);
  
    text-align: center;
  }
  
  #HeaderText {
    text-align: left;
  }
  
  .topContainer {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  #SupportTable {
    padding: 1.5rem;
  }
  .CentreSupportText {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  
  .TextInputs {
    padding-top: 1rem;
    padding-bottom: 1.5rem;
    text-align: center;
    margin-left: 3rem;
    margin-right: 3rem;
  }
  
  .topRow {
    margin-bottom: 1rem;
    padding-top: 0.5rem;
  }
  .bottomRow {
    margin-bottom: 1rem;
  }
  
  .radioButtonContainer {
    display: inline-flex;
    text-align: center;
    margin: none;
    padding: none;
    margin-bottom: 2rem;
    margin-top: 1rem;
  }
  
  .radioButtonRow {
    margin: auto 0;
    align-items: center;
    background-color: white;
    border: solid 1px rgb(230, 230, 230);
    border-radius: 25px;
    padding: 1.5rem;
  }
  
  .mb-3 {
    margin-bottom: 0 !important;
  }
  
  .supportInputCol {
    background-color: red;
    width: 100%;
  }
  .form-control {
    width: 100%;
    border: solid 1px rgba(200, 200, 200, 0.5);
    border-radius: 25px;
    background-color: rgb(245, 245, 245);
    font-size: 0.9rem;
  }
  
  .leftBox {
    float: left;
    width: 50%;
  }
  
  .rightBox {
    float: right;
    width: 50%;
  }
  
  .leftBox,
  .rightBox {
    padding-bottom: 1.25rem;
  }
  
  .leftText {
    height: 100%;
    width: 33%;
    float: left;
    color: black;
    padding: none;
    margin: none;
  }
  
  .rightText {
    padding: none;
    margin: none;
    width: 67%;
    color: black;
    float: right;
  }
  
  .inputText {
    color: black;
    width: 100%;
  }
  
  .supportTextArea {
    border-radius: 10px;
    padding: 0.5rem;
    width: 33%;
  }
  
  .outerGreyContainer {
    border-radius: 25px;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  
  .inputBoxContainer {
    margin: auto 0;
    align-items: center;
    background-color: white;
    border: solid 1px rgb(230, 230, 230);
    border-radius: 25px;
    padding-top: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .inputBoxContainer::after {
    content: "";
    clear: both;
    display: table;
  }
  
  .descriptionHelper {
    margin-bottom: 2rem;
  }
  
  .buttonRow {
    padding-bottom: 1.5rem;
    padding-top: 0.5rem;
  }
  </style>
  